import { FetchState } from 'src/enums/FetchState';

import { fetchRequest } from 'src/utils/fetchRequest';

type enrolRequestData = {
	ContactId?: string;
	Code?: string;
};

export async function enrolRequest(formData: enrolRequestData) {
	const endpoint = '/customapi/MyRcnElearning/Enroll';

	try {
		const response = await fetchRequest(endpoint, formData);

		if (!response.ok) {
			throw response.status;
		}

		return FetchState.SUCCESS;
	} catch (error) {
		console.error(error);
		return error !== 409 ? FetchState.ERROR : FetchState.WARNING;
	}
}
